<template>
  <div>
   
<div class="topbar">
  <div class="topbar-left">
    <button class="menu-toggle" @click="toggleSidebar">
      <svg viewBox="0 0 24 24"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
    </button>
    <!-- <div class="topbar-logo" @click="toggleSidebar">
      <svg viewBox="0 0 24 24"><path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/></svg>
    </div> -->
    <div>
      <div class="topbar-title">ລະບົບຈັດການໂຮງຮຽນ</div>
      <div class="topbar-subtitle">School Management System</div>
    </div>
  </div>
  <div class="topbar-right">
    <div class="notif-wrap">
      <button class="tb-btn" @click.stop="toggleNotifDropdown">
        🔔 ແຈ້ງເຕືອນ <span v-if="unreadCount > 0" class="notif-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      </button>
      <div v-if="showNotifDropdown" class="notif-dropdown" @click.stop>
        <div class="notif-dropdown-head">ແຈ້ງເຕືອນ</div>
        <div v-if="notifications.length === 0" class="notif-empty">ບໍ່ມີແຈ້ງເຕືອນ</div>
        <div v-else class="notif-list">
          <div v-for="n in notifications" :key="n._id" class="notif-item" :class="{ unread: !n.is_read }" @click="openNotification(n)">
            <div class="notif-title">{{ n.title }}</div>
            <div class="notif-message">{{ n.message }}</div>
            <div class="notif-time">{{ formatNotifTime(n.created_at) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="user-pill">
      <div class="user-avatar" :title="userFullName">{{ initials }}</div>
      <span class="user-name">{{ userFullName }}</span>
    </div>
    <button class="tb-btn logout-btn" @click="handleLogout">🚪 ອອກ</button>
  </div>
</div>

<div class="sidebar" :class="{ 'sidebar-open': showSidebar }">
  <div class="nav-section">
    <div class="nav-label">ເມນູຫຼັກ</div>
   
    <!-- Render ເມນູທັງໝົດແບບ Dynamic ຈາກ menuGroups -->
    <div v-for="group in menuGroups" :key="group.id" class="nav-group" :class="{ 'is-open': openMenus[group.id] }">
      <div v-show="hasBit(group.id, 0) "  class="nav-item" :class="{ 'active': isGroupActive(group) }" @click="toggleMenu(group.id)">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="currentColor">
          <path :d="group.icon" />
          <path v-if="group.extraPath" :d="group.extraPath" />
        </svg>
        {{ group.title }}  
        <span class="chevron"></span>
      </div>
      <div class="sub-menu">
        <template v-for="item in (group.items || [])" >
          <div  v-if="item.isHeader" :key="'h-' + item.id" class="sub-label"> {{ item.title }}</div>
          <router-link    v-show="hasBit(item.id, 0) "   v-else :key="'i-' + (item.id || item.to)" class="sub-nav-item" :to="item.to+'?id='+item.id" exact  @click.native="handleNavItemClick">    {{ item.title }}</router-link>
        </template>
      </div>
    </div>
  </div>
</div>

<div class="sidebar-overlay" v-if="showSidebar && isMobile" @click="toggleSidebar"></div>

<div class="main" :class="{ 'main-full': !showSidebar }">
  <router-view />
</div>
  </div>
</template>

<script>
import api from '@/utils/api';
import { auth } from '@/utils/auth';
import { menuGroups } from '@/utils/menu';

export default {
  name: 'HomePage',
  data() {
    return {
      showSidebar: window.innerWidth > 1024,
      isMobile: window.innerWidth <= 1024,
      user: null,
      openMenus: {
      },
      menuGroups,
      permissionState: {},
      notifications: [],
      unreadCount: 0,
      showNotifDropdown: false,
      notifPollTimer: null

    }
  },
  computed: {
    filteredMenuGroups() {
      if (!this.user) return [];
      const userLevel = parseInt(this.user.user_level);
      const permissions = this.user.permissions || {};

      return (this.menuGroups || [])
        .filter((group) => {
          // Admin (Level 1) ສາມາດເຫັນທຸກກຸ່ມເມນູ
          if (userLevel === 1) return true;
          // ກວດສອບລະດັບສິດ (Required Level)
        //  if (group.requiredLevel && userLevel > group.requiredLevel) return false;
          // ກຸ່ມ 'main' (Dashboard) ໃຫ້ສະແດງຕະຫຼອດ
          if (group.id === 'main') return true;
          // ກວດສອບສິດ Bit 0 (View) ຂອງກຸ່ມຫຼັກ
          return (permissions[group.id] & 1) !== 0;
        })
        .map((group) => ({
          ...group,
          items: (group.items || []).filter((item) => {
            if (userLevel === 1) return true;
         //   if (item.requiredLevel && userLevel > item.requiredLevel) return false;
            if (group.id === 'main') return true;
            // ກວດສອບສິດ Bit 0 (View) ຂອງແຕ່ລະເມນູຍ່ອຍ
            return (permissions[item.id] & 1) !== 0;
          }),
        }))
        // ສະແດງສະເພາະກຸ່ມທີ່ມີເມນູຍ່ອຍທີ່ໄດ້ຮັບສິດເທົ່ານັ້ນ
        .filter((group) => group.items.length > 0);
    },
    userFullName() {
      return this.user ? (this.user.fullname || this.user.username) : 'ກຳລັງໂຫຼດ...';
    },
    initials() {
      if (!this.user) return '??';
      return this.userFullName.charAt(0).toUpperCase();
    }
  },
  watch: {
    // ກວດສອບການປ່ຽນ Route: ຖ້າເຂົ້າໜ້າລົງທະບຽນ ໃຫ້ປິດ Sidebar ອັດຕະໂນມັດ
    $route: {
      immediate: true,
      handler(to) {
        if (to.path.includes('/home/students/new') || to.path.includes('/home/academic/new-year')) {
          this.showSidebar = true;
        }
        // ອັບເດດສະຖານະການເປີດຂອງແຕ່ລະກຸ່ມເມນູໃຫ້ສອດຄ່ອງກັບ Route ປະຈຸບັນ
        this.menuGroups.forEach(group => {
          this.$set(this.openMenus, group.id, this.isGroupActive(group));
        });
      }
    }
  },
  mounted() {
    this.user=auth.getUserInfo();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    this.fetchRolePermissions(this.user.user_level);
    // Initialize openMenus based on groups
    this.menuGroups.forEach(g => {
      if (this.openMenus[g.id] === undefined) {
        this.$set(this.openMenus, g.id, this.isGroupActive(g));
      }
    });
    this.loadUserInfo();
    // ຖ້າ Component ອື່ນແຈ້ງວ່າຂໍ້ມູນຜູ້ໃຊ້ອັບເດດ, ໃຫ້ໂຫຼດໃໝ່ທັນທີ
    window.addEventListener('user-info-updated', this.loadUserInfo);

    document.addEventListener('click', this.closeNotifDropdown);
    this.fetchUnreadCount();
    this.notifPollTimer = setInterval(this.fetchUnreadCount, 60000);
  },
  beforeUnmount() {
    // ຢ່າລືມລຶບ Event Listener ເມື່ອ Component ຖືກທຳລາຍ
    window.removeEventListener('user-info-updated', this.loadUserInfo);
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.closeNotifDropdown);
    if (this.notifPollTimer) clearInterval(this.notifPollTimer);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 1024;
      // ໃນ desktop ໃຫ້ເປີດ sidebar ໄວ້ສະເໝີ, ໃນ mobile ໃຫ້ປິດໄວ້ກ່ອນ
      this.showSidebar = !this.isMobile;
    },
    async loadUserInfo() {
      const savedInfo = localStorage.getItem('user-info');
      if (savedInfo) {
        try {
          const user = JSON.parse(savedInfo);
          this.user = user;

          // ຖ້າບໍ່ແມ່ນ Admin ໃຫ້ໄປດຶງສິດທິ (Permissions) ມາຈາກຖານຂໍ້ມູນ
          // ໝາຍເຫດ: role_id ໃນລະບົບນີ້ ຄືກັນກັບ user_level (1=Admin, 2=Manager, 3=Teacher) —
          // ຜູ້ໃຊ້ບໍ່ເຄີຍມີ field role_id ແຍກຕ່າງຫາກ ຈຶ່ງໃຊ້ user_level ເປັນ fallback ສະເໝີ
          if (parseInt(user.user_level) !== 1) {
            await this.fetchUserPermissions(user.role_id || user.user_level);
          }
        } catch (e) {
          console.error('Error parsing user-info', e);
          this.user = { username: 'Guest' };
        }
      }
    },
    async fetchUserPermissions(roleId) {
      try {
        const res = await api.get(`/getRowsInt/permissions/role_id/${roleId}`);
        if (res.data && res.data.length > 0) {
          // ອັບເດດສິດທິເຂົ້າໃນ Object user
          this.$set(this.user, 'permissions', res.data[0].permissions || {});
          
          // ເຊັບລົງ localStorage ຄືນເພື່ອໃຫ້ Component ອື່ນໆນຳໃຊ້ໄດ້ນຳ
          localStorage.setItem('user-info', JSON.stringify(this.user));
        }
      } catch (error) {
        console.error('Fetch permissions error:', error);
      }
    },
    isGroupActive(group) {
      // ກວດສອບວ່າມີເມນູຍ່ອຍອັນໃດອັນໜຶ່ງໃນກຸ່ມນີ້ທີ່ກົງກັບ Path ປະຈຸບັນຫຼືບໍ່
      if (!group.items) return false;
      return group.items.some(item => this.$route.path === item.to);
    },
    handleAction(action) {
      console.log('Action clicked:', action);
      // Add routing or modal logic here
      this.$emit('action', action);
    },
    toggleMenu(menu) {
      // Toggle selected menu and close others
      const currentState = this.openMenus[menu];
      Object.keys(this.openMenus).forEach(key => {
        this.openMenus[key] = false;
      });
      this.openMenus[menu] = !currentState;
    },
    handleNavItemClick() {
      // ເອີ້ນໃຊ້ toggleSidebar ຫຼື ປິດ Sidebar ອັດຕະໂນມັດ ຖ້າເປັນໜ້າຈໍມືຖື (Responsive)
      if (this.isMobile) {
        this.showSidebar = false;
      }
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    handleLogout() {
      // Clear authentication data
      auth.logout();
      // ລຶບຂໍ້ມູນ session ແລະ ຂໍ້ມູນຜູ້ໃຊ້ອອກຈາກ localStorage
      localStorage.removeItem('user-token');
      localStorage.removeItem('user-info');
      // Redirect to login page
      this.$router.push({ name: 'Login' });
    },
     async fetchRolePermissions(roleId) {
      this.loadingPermissions = true;
      try {
        const res = await api.get(`/getRowsInt/permissions/role_id/${roleId}`);
        if (res.data && res.data.length > 0) {
          this.permissionState = res.data[0].permissions || {};
          this.permissionRecordId = res.data[0]._id;
        } else {
          // ຫາກບໍ່ພົບຂໍ້ມູນ ໃຫ້ຕັ້ງຄ່າເລີ່ມຕົ້ນ
          this.permissionRecordId = null;
          const defaults = {};
          this.menuGroups.forEach(group => {
            // ຕັ້ງຄ່າເລີ່ມຕົ້ນໃຫ້ກຸ່ມຫຼັກ
            defaults[group.id] = roleId === 1 ? 7 : 1;
            group.items.forEach(item => {
              // ຖ້າເປັນ Admin ໃຫ້ສິດເຕັມ (7), ຖ້າບໍ່ແມ່ນໃຫ້ສິດເບິ່ງຢ່າງດຽວ (1)
              defaults[item.id] = roleId === 1 ? 7 : 1;
            });
          });
          this.permissionState = defaults;
        }
      } catch (e) {
        console.error('Fetch permissions error:', e);
      } finally {
        this.loadingPermissions = false;
      }
    },
    hasBit(moduleKey, bit) {
      const val = this.permissionState[moduleKey] || 0;
      return (val & (1 << bit)) !== 0;
    },
    async fetchUnreadCount() {
      if (!this.user || !this.user.username) return;
      try {
        const res = await api.get('/notifications/unread-count', { params: { user_id: this.user.username } });
        if (res.data.code === 1) this.unreadCount = res.data.count;
      } catch (e) {
        console.error('fetchUnreadCount error:', e);
      }
    },
    async fetchNotifications() {
      if (!this.user || !this.user.username) return;
      try {
        const res = await api.get('/notifications', { params: { user_id: this.user.username } });
        if (res.data.code === 1) this.notifications = res.data.rows;
      } catch (e) {
        console.error('fetchNotifications error:', e);
      }
    },
    toggleNotifDropdown() {
      this.showNotifDropdown = !this.showNotifDropdown;
      if (this.showNotifDropdown) this.fetchNotifications();
    },
    closeNotifDropdown() {
      this.showNotifDropdown = false;
    },
    formatNotifTime(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleString('lo-LA', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    },
    async openNotification(n) {
      this.showNotifDropdown = false;
      if (!n.is_read) {
        try {
          await api.post(`/notifications/${n._id}/read`);
          n.is_read = true;
          this.unreadCount = Math.max(0, this.unreadCount - 1);
        } catch (e) {
          console.error('mark notification read error:', e);
        }
      }
      if (n.ref_type === 'student_transfer' && n.ref_id) {
        this.$router.push(`/home/students/transfer/detail/${n.ref_id}`);
      }
    },
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Lao:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@300;400;500;600&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;}
  :root{
    --lao:#003F8A;
    --lao-mid:#1565C0;
    --lao-light:#E8F0FE;
    --gold:#C9962B;
    --gold-light:#FFF8E1;
    --red:#CC0000;
    --surface:#ECEFF1; /* muted light gray */
    --card:#FFFFFF;
    --text1:#0D1B2A;
    --text2:#4A5568;
    --text3:#8898AA;
    --border:#E2E8F0;
    --success:#1A7F4B;
    --success-bg:#E8F5EE;
    --warning:#B45309;
    --warning-bg:#FEF3C7;
    --danger:#C0392B;
    --danger-bg:#FDEEEE;
  }
  body{font-family:'IBM Plex Sans','Noto Sans Lao',sans-serif;background:linear-gradient(180deg,#f4f5f7 0%, #eceff1 100%);color:var(--text1);min-height:100vh;font-size:14px;}

  .topbar{background:var(--lao);display:flex;align-items:center;justify-content:space-between;padding:0 24px;height:56px;position:sticky;top:0;z-index:100;}
  .topbar-left{display:flex;align-items:center;gap:12px;}
  .topbar-logo{width:36px;height:36px;border-radius:50%;background:var(--gold);display:flex;align-items:center;justify-content:center;}
  .topbar-logo svg{width:22px;height:22px;fill:#fff;}
  .topbar-title{color:#fff;font-size:15px;font-weight:600;letter-spacing:0.01em;}
  .topbar-subtitle{color:rgba(255,255,255,0.6);font-size:11px;font-weight:300;}
  .topbar-right{display:flex;align-items:center;gap:16px;}
  .tb-btn{background:rgba(255,255,255,0.1);border:none;color:#fff;padding:6px 14px;border-radius:6px;font-size:13px;cursor:pointer;display:flex;align-items:center;gap:6px;font-family:inherit;}
  
  .menu-toggle {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    display: block; /* ສະແດງປຸ່ມ Toggle ຕະຫຼອດເວລາ */
  }
  .menu-toggle svg { width: 24px; height: 24px; fill: #fff; }

  .tb-btn:hover{background:rgba(255,255,255,0.18);}
  .tb-btn.logout-btn{background:rgba(255,68,68,0.2);}
  .tb-btn.logout-btn:hover{background:rgba(255,68,68,0.3);}
  .notif-badge{background:var(--red);color:#fff;font-size:10px;font-weight:700;padding:2px 6px;border-radius:10px;}
  .notif-wrap{position:relative;}
  .notif-dropdown{position:absolute;top:calc(100% + 8px);right:0;width:340px;max-height:420px;overflow-y:auto;background:#fff;border-radius:10px;box-shadow:0 12px 32px rgba(0,0,0,0.18);z-index:200;}
  .notif-dropdown-head{padding:12px 16px;font-weight:700;font-size:13px;color:var(--text1);border-bottom:1px solid var(--border);}
  .notif-empty{padding:30px 16px;text-align:center;color:var(--text3);font-size:12.5px;}
  .notif-list{display:flex;flex-direction:column;}
  .notif-item{padding:12px 16px;border-bottom:1px solid var(--border);cursor:pointer;}
  .notif-item:hover{background:var(--surface);}
  .notif-item.unread{background:var(--lao-light);}
  .notif-item:last-child{border-bottom:none;}
  .notif-title{font-size:13px;font-weight:700;color:var(--text1);}
  .notif-message{font-size:12px;color:var(--text2);margin-top:3px;line-height:1.5;}
  .notif-time{font-size:10.5px;color:var(--text3);margin-top:6px;}
  .user-pill{display:flex;align-items:center;gap:8px;color:rgba(255,255,255,0.9);font-size:13px;}
  .user-avatar{width:30px;height:30px;border-radius:50%;background:var(--gold);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:600;color:#fff;}

  /* Sidebar Links reset decoration */
  .sidebar .nav-item { text-decoration: none; }
  .sidebar{position:fixed;left:0;top:56px;bottom:0;width:280px;background:var(--card);border-right:1px solid var(--border);display:flex;flex-direction:column;padding:16px 0;overflow-y:auto;z-index:90;transition: transform 0.3s ease;transform: translateX(0);}
  .sidebar:not(.sidebar-open) { transform: translateX(-100%); } /* ຍຸບ Sidebar ໂດຍການດັນອອກທາງຊ້າຍ */

  .nav-section{margin-bottom:4px;}

  /* Navigation Grouping Styles */
  .nav-group .sub-menu {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
    background: #f8fafc;
  }
  .nav-group.is-open .sub-menu {
    max-height: 1000px;
    transition: max-height 0.5s ease-in;
    border-bottom: 1px solid var(--border);
  }
  .sub-nav-item {
    display: block;
    padding: 8px 20px 8px 48px;
    color: var(--text2);
    font-size: 12.5px;
    text-decoration: none;
    transition: all 0.2s;
  }
  .sub-nav-item:hover {
    color: var(--lao);
    background: var(--lao-light);
  }
  /* Style ສຳລັບເມນູຍ່ອຍທີ່ຖືກເລືອກ (Active Submenu) */
  .sub-nav-item.router-link-active {
    color: var(--lao);
    background: var(--lao-light);
    font-weight: 600;
    border-right: 3px solid var(--lao);
  }
  .sub-label {
    padding: 10px 20px 4px 48px;
    font-size: 11px;
    font-weight: 700;
    color: var(--lao);
    text-transform: uppercase;
  }
  .chevron {
    margin-left: auto;
    border: solid var(--text3);
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    transition: transform 0.3s;
  }
  .is-open .chevron { transform: rotate(-135deg); }

  .nav-label{font-size:10px;font-weight:600;color:var(--text3);text-transform:uppercase;letter-spacing:0.08em;padding:8px 20px 4px;}
  .nav-item{display:flex;align-items:center;gap:10px;padding:9px 20px;color:var(--text2);font-size:13px;cursor:pointer;transition:all 0.15s;border-left:3px solid transparent;}
  .nav-item:hover{background:var(--lao-light);color:var(--lao);}
  .nav-item.active{background:var(--lao-light);color:var(--lao);border-left-color:var(--lao);font-weight:500;}
  .nav-icon{width:18px;height:18px;opacity:0.7;flex-shrink:0;}
  .nav-item.active .nav-icon{opacity:1;}
  .nav-count{margin-left:auto;background:var(--lao);color:#fff;font-size:10px;font-weight:700;padding:2px 7px;border-radius:10px;}
  .nav-count.warn{background:var(--warning);color:#fff;}

  .main{margin-left:280px;margin-top:0;padding:24px;min-height:calc(100vh - 56px);transition: margin-left 0.3s ease;}
  .main.main-full { margin-left: 0; } /* ຂະຫຍາຍເນື້ອໃນໃຫ້ເຕັມຈໍເມື່ອ Sidebar ຖືກຍຸບ */

  .page-header{margin-bottom:24px;}
  .page-header h1{font-size:20px;font-weight:600;color:var(--text1);}
  .page-header p{color:var(--text2);font-size:13px;margin-top:4px;}
  .breadcrumb{display:flex;align-items:center;gap:6px;font-size:12px;color:var(--text3);margin-bottom:8px;}
  .breadcrumb span{color:var(--lao);}

  .kpi-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;margin-bottom:24px;}
  .kpi-card{background:var(--card);border:1px solid var(--border);border-radius:10px;padding:16px 20px;position:relative;overflow:hidden;}
  .kpi-card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;}
  .kpi-card.blue::before{background:var(--lao);}
  .kpi-card.gold::before{background:var(--gold);}
  .kpi-card.green::before{background:var(--success);}
  .kpi-card.red::before{background:var(--danger);}
  .kpi-label{font-size:12px;color:var(--text3);font-weight:500;text-transform:uppercase;letter-spacing:0.05em;}
  .kpi-value{font-size:26px;font-weight:600;color:var(--text1);margin:6px 0 4px;letter-spacing:-0.02em;}
  .kpi-sub{font-size:12px;color:var(--text3);}
  .kpi-badge{display:inline-flex;align-items:center;gap:4px;font-size:11px;font-weight:500;padding:2px 8px;border-radius:12px;margin-top:6px;}
  .kpi-badge.up{background:var(--success-bg);color:var(--success);}
  .kpi-badge.down{background:var(--danger-bg);color:var(--danger);}
  .kpi-badge.warn{background:var(--warning-bg);color:var(--warning);}

  .two-col{display:grid;grid-template-columns:1fr 320px;gap:16px;margin-bottom:24px;}
  .panel{background:var(--card);border:1px solid var(--border);border-radius:10px;}
  .panel-head{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid var(--border);}
  .panel-head h3{font-size:14px;font-weight:600;color:var(--text1);}
  .panel-action{font-size:12px;color:var(--lao);cursor:pointer;font-weight:500;}
  .panel-body{padding:16px 20px;}

  .table-wrap{overflow-x:auto;}
  table{width:100%;border-collapse:collapse;font-size:13px;}
  th{text-align:left;font-size:11px;font-weight:600;color:var(--text3);text-transform:uppercase;letter-spacing:0.06em;padding:0 12px 10px;}
  td{padding:10px 12px;border-top:1px solid var(--border);color:var(--text2);vertical-align:middle;}
  tr:hover td{background:var(--surface);}
  .asset-name{color:var(--text1);font-weight:500;}
  .asset-code{font-size:11px;color:var(--text3);font-family:'IBM Plex Mono',monospace;}
  .status-pill{display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:500;}
  .status-pill.active{background:var(--success-bg);color:var(--success);}
  .status-pill.repair{background:var(--warning-bg);color:var(--warning);}
  .status-pill.disposed{background:#F0F0F0;color:var(--text3);}
  .status-pill.lost{background:var(--danger-bg);color:var(--danger);}

  .activity-list{display:flex;flex-direction:column;gap:0;}
  .activity-item{display:flex;align-items:flex-start;gap:12px;padding:12px 0;border-bottom:1px solid var(--border);}
  .activity-item:last-child{border-bottom:none;}
  .act-icon{width:32px;height:32px;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:14px;}
  .act-icon.add{background:var(--lao-light);color:var(--lao);}
  .act-icon.edit{background:var(--warning-bg);color:var(--warning);}
  .act-icon.del{background:var(--danger-bg);color:var(--danger);}
  .act-icon.transfer{background:var(--success-bg);color:var(--success);}
  .act-text{flex:1;}
  .act-text strong{font-size:13px;color:var(--text1);font-weight:500;}
  .act-text p{font-size:11px;color:var(--text3);margin-top:2px;}
  .act-time{font-size:11px;color:var(--text3);white-space:nowrap;}

  .chart-area{height:140px;display:flex;align-items:flex-end;gap:8px;padding-top:8px;}
  .bar-group{flex:1;display:flex;flex-direction:column;align-items:center;gap:4px;}
  .bar{width:100%;border-radius:4px 4px 0 0;min-height:4px;transition:opacity 0.2s;cursor:pointer;}
  .bar:hover{opacity:0.8;}
  .bar-label{font-size:10px;color:var(--text3);}

  .alert-list{display:flex;flex-direction:column;gap:10px;}
  .alert-item{display:flex;align-items:center;gap:12px;padding:12px 16px;border-radius:8px;border:1px solid;}
  .alert-item.warn{background:var(--warning-bg);border-color:#FCD34D;}
  .alert-item.danger{background:var(--danger-bg);border-color:#FCA5A5;}
  .alert-icon{font-size:18px;}
  .alert-text strong{font-size:13px;}
  .alert-text p{font-size:12px;opacity:0.8;margin-top:2px;}

  .three-col{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-bottom:24px;}
  .quick-btn{background:var(--card);border:1px solid var(--border);border-radius:10px;padding:20px;cursor:pointer;transition:all 0.15s;text-align:center;}
  .quick-btn:hover{border-color:var(--lao);background:var(--lao-light);}
  .quick-btn:hover .qb-icon{background:var(--lao);color:#fff;}
  .qb-icon{width:44px;height:44px;border-radius:10px;background:var(--surface);display:flex;align-items:center;justify-content:center;margin:0 auto 10px;font-size:20px;transition:all 0.15s;}
  .quick-btn h4{font-size:13px;font-weight:600;color:var(--text1);}
  .quick-btn p{font-size:11px;color:var(--text3);margin-top:4px;}

  .donut-row{display:flex;align-items:center;gap:20px;}
  .donut-svg{flex-shrink:0;}
  .donut-legend{flex:1;}
  .legend-item{display:flex;align-items:center;justify-content:space-between;padding:5px 0;font-size:12px;}
  .legend-dot{width:10px;height:10px;border-radius:50%;flex-shrink:0;}
  .legend-name{color:var(--text2);flex:1;margin-left:8px;}
  .legend-val{font-weight:600;color:var(--text1);}
  .legend-pct{color:var(--text3);font-size:11px;margin-left:6px;}

  /* RESPONSIVE BREAKPOINTS */
  @media (max-width: 1024px) {
    .main { margin-left: 0 !important; padding: 16px; }
    
    .sidebar { width: 280px; box-shadow: 10px 0 30px rgba(0,0,0,0.1); }
    
    .sidebar-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.4);
      backdrop-filter: blur(4px);
      z-index: 85;
    }
    .topbar-subtitle { display: none; }
  }

  @media (max-width: 768px) {
    .three-col { grid-template-columns: 1fr; }
    .topbar-subtitle, .user-name { display: none; }
    .topbar { padding: 0 12px; }
    .kpi-grid { grid-template-columns: 1fr; }
  }

  @media (max-width: 480px) {
    .topbar-right { gap: 8px; }
    .tb-btn { padding: 6px 8px; font-size: 11px; }
    .page-header h1 { font-size: 18px; }
    
    .donut-row { flex-direction: column; text-align: center; }
    .donut-legend { width: 100%; }
    
    table { min-width: 600px; }
    .table-wrap {
      margin: 0 -20px;
      padding: 0 20px;
    }
  }

  @media print {
    .topbar, .sidebar, .sidebar-overlay, .menu-toggle { display: none !important; }
    .main { margin-left: 0 !important; padding: 0 !important; width: 100% !important; background: white !important; }
    body { background: white !important; }
  }

</style>
